import { AxiosResponse } from 'axios';
import { User } from '@/types/api/users.types';
import { axiosRequest } from '@/common/api/instance';
import { Response as ApiResponse } from '@/types/api/response.types';

const resource = '/users';

export const getCurrentUser = async (): Promise<AxiosResponse<ApiResponse<User>>> => {
  return axiosRequest().get(`${resource}/current`);
};
